export default "__VITE_ASSET__CA9iYe8P__"